import { ParticipantRestrictionDto } from './participant-restriction.dto';

export class DanceClassRulesDto {
  participantRestriction?: ParticipantRestrictionDto;
}
